import * as React from "react";
import { GafOktaManager } from "../../auth/gaf-okta-auth";
import * as CONFIG from "../../../config.json";
import ConstantFile from "../../constants/constantFile";
import { removeWindowBeforeUnload } from "../../utils/utils";
/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
class IdleTimeout extends React.Component<any, any> {
    events: any;
    logoutTimeout: any;

    constructor(props: any) {
        super(props);
        this.events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];
        this.logout = this.logout.bind(this);
        this.state = { isIdle: false };
        this.resetTimeout = this.resetTimeout.bind(this);
    }

    componentDidMount() {
        this.destroy();
        for (const i in this.events) {
            window.addEventListener(this.events[i], this.resetTimeout);
        }
        this.setTimeout();
    }

    componentWillUnmount() {
        this.destroy();
    }

    clearTimeout() {
        if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
    }

    setTimeout() {
        const IdleTimeout = CONFIG.IDLE_TIMEOUT_MINUTES * 60 * 1000;
        this.logoutTimeout = setTimeout(this.logout, IdleTimeout);
    }

    resetTimeout() {
        this.clearTimeout();
        this.setTimeout();
    }

    logout() {
        this.destroy();
        removeWindowBeforeUnload();
        // alert('Your session has expired due to inactivity');
        this.setState({ isIdle: true });
    }

    destroy() {
        for (const i in this.events) {
            window.removeEventListener(this.events[i], this.resetTimeout);
        }
        this.clearTimeout();
    }

    render() {
        if (this.state.isIdle) {
            try {
                const { gafLogins, stdOktaLogoutUrl } = ConstantFile;
                const stdOktaLogoutRedirectUrl = `${stdOktaLogoutUrl}${CONFIG.OKTA_CONFIG.loginUrl}`;
                const { profile } = GafOktaManager.storage.info;
                const userEmail = profile !== undefined && profile.email;
                const userEmailSplit = userEmail && userEmail.split("@");
                const userEmailDomain = userEmailSplit && userEmailSplit[userEmailSplit.length - 1].toLowerCase();
                const logoutUrl = gafLogins.includes(userEmailDomain) === true ? stdOktaLogoutRedirectUrl : null;
                GafOktaManager.logout(logoutUrl);
            } catch (err) {
                GafOktaManager.logout();
            }
        }
        return <></>;
    }
}

export default IdleTimeout;
